import { IonContent } from "@ionic/react";
import { useMemo, useState } from "react";
import { cards } from "../assets/cards";
import { useTranslate } from "../contexts/translate";
import { Background } from "../components/ui/Background";
import {
  CategorySubheader,
  CategoryType,
} from "../components/CategorySubheader";
import { CardProps } from "../components/Card";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import Searchbar from "../components/ui/Searchbar";
import { Header } from "../components/ui/Header";

export function capitalize(s: string) {
  return s[0].toUpperCase() + s.slice(1);
}

const CardsContainer = styled(IonContent)`
  width: 100%;
  --padding-top: 3vw;
  --padding-start: 3vw;
  --background: transparent;

  @media (orientation: landscape) {
    --padding-start: 35vw;
    --padding-end: 35vw;
  }
`;

const CartItemTitle = styled(Link)`
  display: block;
  margin: 2% 0;
  font-size: 0.8em;
  color: black;
  text-decoration: none;
`;

function CardItem(props: { card: CardProps; category: CategoryType }) {
  const { translate } = useTranslate();
  return (
    <CartItemTitle to={`/cards/${props.category}/${props.card.id}`}>
      {translate(`screens.category.${props.category}CardsTitle`, {
        id: props.card.id,
        title: props.card.title,
      })}
    </CartItemTitle>
  );
}

export function Category() {
  const { lang, translate } = useTranslate();
  const { type } = useParams<{ type: CategoryType }>();
  const [search, setSearch] = useState("");
  const localizedCards = cards[lang as any] || [];

  const filteredCards = useMemo(() => {
    let filteredCards = localizedCards;
    if (type) {
      filteredCards = filteredCards.filter((c) => type.startsWith(c.type));
    }
    if (search) {
      filteredCards = filteredCards.filter((c) =>
        c.title.toLocaleLowerCase().includes(search)
      );
    }
    return filteredCards as CardProps[];
  }, [search, type]);

  if (!type) {
    return null;
  }

  return (
    <>
      <Header size="small" shouldHide />
      <IonContent>
        <Background background="cards">
          <CategorySubheader category={type}></CategorySubheader>
          <Searchbar
            value={search}
            onChange={(e) =>
              setSearch(e.target.value?.toLocaleLowerCase() || "")
            }
            placeholder={translate("screens.category.search")}
          />
          <CardsContainer>
            {filteredCards.map((card) => (
              <CardItem card={card} key={card.id} category={type} />
            ))}
          </CardsContainer>
        </Background>
      </IonContent>
    </>
  );
}
